import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const DividerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
const Hr = styled.hr`
  width: 100%;
  border: ${({ color }) => `1px solid ${color}`};
`;

const BuilderDivider = (props) => {
  const { backgroundColor, color } = props;

  return (
    <DividerContainer
      backgroundColor={backgroundColor}
      data-builder-component-type="divider"
    >
      <Hr color={color} />
    </DividerContainer>
  );
};

BuilderDivider.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
};

export default BuilderDivider;
